import React from 'react';
import { Drawer, Box } from '@mui/material';

const AppDrawer = ({
    open,
    onClose,
    title,
    children,
    width = 480,
}) => {
    return (
        <Drawer
            anchor="right"
            open={open}
            onClose={onClose}
            variant="temporary"
            slotProps={{
                paper: {
                    sx: {
                        width: {
                            xs: '100vw',
                            sm: '420px',
                            md: `${width}px`,
                        },
                        maxWidth: '100vw',
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        boxShadow: '-4px 0 24px rgba(0,0,0,0.10)',
                        borderLeft: '1px solid #e5e7eb',
                        overflow: 'hidden',
                        backgroundColor: '#fff',
                    },
                },
            }}
        >
            <Box
                sx={{
                    flex: 1,
                    overflowY: 'auto',
                    overflowX: 'hidden',
                    scrollBehavior: 'smooth',
                    '&::-webkit-scrollbar': { width: '5px' },
                    '&::-webkit-scrollbar-track': { background: 'transparent' },
                    '&::-webkit-scrollbar-thumb': { background: '#e5e7eb', borderRadius: '10px' },
                    '&::-webkit-scrollbar-thumb:hover': { background: '#d1d5db' },
                }}
            >
                {children}
            </Box>
        </Drawer>
    );
};

export default AppDrawer;
